import _isEmpty from "lodash/isEmpty";
import moment from "moment";

function primaryColorFnc() {
  let primaryColor = document.querySelector(":root").style.getPropertyValue("--study-primary-color");
  primaryColor = primaryColor || "#00C3B3";
  return primaryColor;
}

function getContrast(hexcolor) {
  let hexaDecimalColor = hexcolor;
  if (hexaDecimalColor.slice(0, 1) === "#") {
    hexaDecimalColor = hexaDecimalColor.slice(1);
  }

  if (hexaDecimalColor.length === 3) {
    hexaDecimalColor = hexaDecimalColor
      .split("")
      .map(function(hex) {
        return hex + hex;
      })
      .join("");
  }

  const r = parseInt(hexaDecimalColor.substr(0, 2), 16) * 299;
  const g = parseInt(hexaDecimalColor.substr(2, 2), 16) * 587;
  const b = parseInt(hexaDecimalColor.substr(4, 2), 16) * 114;

  const yiq = (r + g + b) / 1000;
  return yiq >= 128 ? "#000000" : "#ffffff";
}

function getDailySpirometerReadingTooltip(data) {
  return `<div>
		<div style="font-family: 'RobotoMedium'; font-size: 12px;">${data.participant_id}</div>
		<div style="font-family: 'RobotoRegular'; font-size: 10px;">
			<div>Mean Reading: ${data.mean_reading}</div>
			<div>Number of Readings: ${data.number_of_readings}</div>
			<div>${data.date}</div>
		</div>
	</div>`;
}

function expectedDataFields() {
  return [
    {
      key: "is_participant_active",
      label: "*",
      sortable: true,
      thStyle: { width: "40px" }
    },
    {
      key: "participantId",
      label: "Participant",
      sortable: true,
      thStyle: { width: "85px" }
    },
    {
      key: "expected_missing_date",
      label: "Expected & Missing",
      sortable: true,
      thStyle: { width: "135px" }
    },
    {
      key: "most_recent_data",
      sortable: true,
      thStyle: { width: "125px" }
    },
    {
      key: "days_missing",
      sortable: true,
      thStyle: { width: "92px" }
    }
  ];
}

function expectedRecentDataItems(rawData) {
  return rawData;
}

function recentDataFields(widthStyle, analyteFilters) {
  const res = [
    {
      key: "participantId",
      label: "Participant",
      sortable: true,
      thStyle: { [widthStyle]: "120px" }
    },
    {
      key: "startDate",
      sortable: true,
      thStyle: { [widthStyle]: "165px" }
    },
    { key: "reading", sortable: true, thStyle: { [widthStyle]: "75px" } }
  ];

  if (analyteFilters.includes("FVC")) {
    res.push(
      {
        key: "fvc",
        label: "FVC",
        sortable: true,
        thStyle: { [widthStyle]: "65px" }
      },
      {
        key: "fvc_unit",
        label: "FVC Unit",
        sortable: true,
        thStyle: { [widthStyle]: "75px" }
      }
    );
  }

  if (analyteFilters.includes("FEV1")) {
    res.push(
      {
        key: "fev1",
        label: "FEV1",
        sortable: true,
        thStyle: { [widthStyle]: "70px" }
      },
      {
        key: "fev1_unit",
        label: "FEV1 Unit",
        sortable: true,
        thStyle: { [widthStyle]: "80px" }
      }
    );
  }

  if (analyteFilters.includes("FEV1 FVC") || analyteFilters.includes("FEV1/FVC")) {
    res.push(
      {
        key: "fev1/fvc",
        label: "FEV1 FVC",
        sortable: true,
        thStyle: { [widthStyle]: "95px" }
      },
      {
        key: "fev1/fvc_unit",
        label: "FEV1 FVC Unit",
        sortable: true,
        thStyle: { [widthStyle]: "110px" }
      }
    );
  }

  if (analyteFilters.includes("FEV6")) {
    res.push(
      {
        key: "fev6",
        label: "FEV6",
        sortable: true,
        thStyle: { [widthStyle]: "75px" }
      },
      {
        key: "fev6_unit",
        label: "FEV6 Unit",
        sortable: true,
        thStyle: { [widthStyle]: "85px" }
      }
    );
  }

  if (analyteFilters.includes("FEF2575")) {
    res.push(
      {
        key: "fef2575",
        label: "FEF2575",
        sortable: true,
        thStyle: { [widthStyle]: "90px" }
      },
      {
        key: "fef2575_unit",
        label: "FEF2575 Unit",
        sortable: true,
        thStyle: { [widthStyle]: "105px" }
      }
    );
  }

  if (analyteFilters.includes("PEF")) {
    res.push(
      {
        key: "pef",
        label: "PEF",
        sortable: true,
        thStyle: { [widthStyle]: "65px" }
      },
      {
        key: "pef_unit",
        label: "PEF Unit",
        sortable: true,
        thStyle: { [widthStyle]: "80px" }
      }
    );
  }

  res.push({
    key: "qualityMessage",
    label: "Quality Message",
    sortable: true,
    thStyle: { [widthStyle]: "145px" }
  });

  return res;
}

function generateDailySpirometerReadingData(analyte, rawData, choosenCountries = [], choosenSites = []) {
  if (_isEmpty(rawData) || choosenCountries.length === 0 || choosenSites.length === 0) {
    return [];
  }
  const response = {};
  let labelPreviousDate = null;
  let labelPreviousBgColor = "#e4e9ee";
  let newRawData = [];

  response.category = [];
  response.data = [];

  newRawData = rawData[analyte];

  if (newRawData.length > 0) {
    // Code for sorting the data by date and participant_id
    newRawData.sort(function compare(a, b) {
      const aDate = moment(a.date, "DD MMM YYYY");
      const bDate = moment(b.date, "DD MMM YYYY");
      if (aDate.isValid && bDate.isValid) {
        if (aDate < bDate) {
          return -1;
        } else if (aDate > bDate) {
          return 1;
        } else {
          if (a.participant_id < b.participant_id) {
            return -1;
          } else if (a.participant_id > b.participant_id) {
            return 1;
          } else {
            return 0;
          }
        }
      }
    });
  }

  // Code for generating category and data for chart.

  newRawData.forEach(data => {
    if (data.mean_reading != null) {
      // Code for applying background color of labels by comparing date.
      const bgColor = primaryColorFnc().replace("#", "");
      const textColor = getContrast(primaryColorFnc()).replace("#", "");

      let labelBgColor;
      if (labelPreviousBgColor == "#f9fafb") {
        labelBgColor = "#e4e9ee";
      } else {
        labelBgColor = "#f9fafb";
      }
      if (data.date == labelPreviousDate) {
        labelBgColor = labelPreviousBgColor;
      }

      const participant_id = data.participant_id.length > 10 ? data.participant_id.substr(0, 10) + "..." : data.participant_id;
      response.category.push({
        label: `<strong>${participant_id}</strong> <br> ${data.date}`,
        bgColor: labelBgColor,
        borderPadding: "8",
        date: data.date,
        participant_id: data.participant_id
      });
      response.data.push({
        value: data.mean_reading,
        anchorImageUrl: `https://ui-avatars.com/api/?background=${bgColor}&color=${textColor}&name=${data.mean_reading}&length=3&bold=true`,
        toolText: getDailySpirometerReadingTooltip(data),
        date: data.date,
        participant_id: data.participant_id
      });

      labelPreviousBgColor = labelBgColor;
      labelPreviousDate = data.date;
    }
  });
  return response;
}

export { expectedDataFields, expectedRecentDataItems, recentDataFields, generateDailySpirometerReadingData, primaryColorFnc, getContrast };
